import { LocaleCard } from 'components/LocaleCard/LocaleCard';
import React, { useState } from 'react';
import { SingleStorageRoomType } from 'types/CommonTypes';
import { Wrapper, LoadMoreStyled } from './StorageListMobile.styled';

interface StorageListMobileProps {
    data: SingleStorageRoomType[];
    investmentSlug: string;
}

export const StorageListMobile = ({
    data,
    investmentSlug,
}: StorageListMobileProps) => {
    const [numberOfRows, setNumberOfRows] = useState(5);
    const cutStorages = data?.slice(0, numberOfRows);
    const loadMore = () => {
        setNumberOfRows((prevState) => prevState + 5);
    };
    return (
        <Wrapper>
            {cutStorages?.map((item: any) => (
                <LocaleCard
                    investmentSlug={investmentSlug}
                    localeNumber={item?.storageRoomNumber}
                    price={item?.storageRoomPrice}
                    status={item?.storageRoomStatus}
                    yardge={item?.storageRoomArea}
                />
            ))}
            {data.length > numberOfRows && (
                <LoadMoreStyled onClick={loadMore}>
                    Załaduj więcej
                </LoadMoreStyled>
            )}
        </Wrapper>
    );
};
